import {
  ProfessionalsReferencesDetailsStore,
  ProfessionalsReferencesDetailsActions,
} from './types';

export const defaultState: ProfessionalsReferencesDetailsStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  errorRelatedReferences: null,
  isLoadingRelatedReferences: false,
  isLoadedRelatedReferences: false,
  article: null,
  relatedReferences: [],
};

const reducer = (
  state: ProfessionalsReferencesDetailsStore = defaultState,
  action: { type: ProfessionalsReferencesDetailsActions; payload?: any }
): ProfessionalsReferencesDetailsStore => {
  const {
    FetchDetailsBegin,
    FetchDetailsError,
    FetchDetailsSuccess,
    FetchRelatedReferencesDetailsBegin,
    FetchRelatedReferencesDetailsSuccess,
    FetchRelatedReferencesDetailsError,
  } = ProfessionalsReferencesDetailsActions;
  switch (action.type) {
    case FetchDetailsBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case FetchDetailsError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case FetchDetailsSuccess: {
      const { ...payload } = action.payload;
      return {
        ...state,
        ...payload,
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }
    case FetchRelatedReferencesDetailsBegin: {
      return {
        ...state,
        isLoadingRelatedReferences: true,
        isLoadedRelatedReferences: false,
        errorRelatedReferences: null,
      };
    }
    case FetchRelatedReferencesDetailsError: {
      return {
        ...state,
        isLoadingRelatedReferences: false,
        isLoadedRelatedReferences: true,
        error: action.payload,
      };
    }
    case FetchRelatedReferencesDetailsSuccess: {
      return {
        ...state,
        relatedReferences: action.payload,
        isLoadingRelatedReferences: false,
        isLoadedRelatedReferences: true,
        errorRelatedReferences: null,
      };
    }
    default: {
      return state;
    }
  }
};
export default reducer;
